// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"85":"camera","177":"home","214":"phone","577":"demo"}[chunkId] + "." + {"85":"1ba8c762","177":"659f6aee","214":"4a5b25d1","577":"ed14a047"}[chunkId] + ".css";
};